import { InputHTMLAttributes, memo } from 'react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  id?: string;
};

const _Radio = ({ label, id, ...restProps }: Props) => {
  return (
    <div className="flex items-center gap-2 relative cursor-pointer">
      <input
        {...restProps}
        type="radio"
        id={id ? id : label}
        readOnly
        className="absolute w-full h-full opacity-0 cursor-pointer peer"
      />
      <label
        htmlFor={label}
        className="peer-checked:before:opacity-100 cursor-pointer text-i_radio_text text-[14px] font-medium pl-6 after:content-[''] after:absolute after:left-0 after:min-w-4 after:h-4 after:rounded-full after:border after:border-i_radio_border before:content-[''] after:bg-i_radio_bg before:z-[2] before:w-2 before:h-2 before:absolute before:rounded-full before:bg-i_radio_active before:left-1 before:opacity-0 before:top-1">
        {label}
      </label>
    </div>
  );
};

export const Radio = memo(_Radio);
